import React, { useState, useEffect } from 'react'
import { Col, Icon, IconButton, Panel, Row } from 'rsuite'
import { startLoading, doneLoading } from '../../../utils/loading'
import ListDepreciationAssetsSearch from './ListDepreciationAssetsSearch'
import ListDepreciationAssetsTable from './ListDepreciationAssetsTable'
import notification from '../../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'
import { cloneDeep } from 'lodash'
import {
  downloadAssetDepreciationReport,
  searchListDepreciationAssets,
} from '../../../redux/actions/listDepreciationAssets'
import { downloadFile } from '../../../utils/fileUtil'

export default function ListDepreciationAssetsWidget(props) {
  const { projectCode } = props

  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [searchRequest, setSearchRequest] = useState({})

  const handleSearch = async (pagenumber, pagesize, request) => {
    setIsLoading(true)
    startLoading()
    try {
      // console.log(pagenumber, pagesize, request)
      setPage(pagenumber)
      setDisplayLength(pagesize)
      setSearchRequest(request)

      const response = await searchListDepreciationAssets(
        projectCode,
        request,
        pagenumber,
        pagesize
      )
      // console.log('response ', response)
      if (response) {
        let _schema = cloneDeep(formSchema)

        _schema.result = response.model
        setFormSchema(_schema)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const onReload = (pagenumber, pagesize) => {
    handleSearch(pagenumber, pagesize, searchRequest)
  }

  const onSearch = (request) => {
    console.log('onSearch===>', request)
    handleSearch(1, displayLength, request)
  }

  const handleExportFile = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      const file = await downloadAssetDepreciationReport(request)
      // console.log(file)
      if (file) {
        downloadFile(file, file.name || `รายงานค่าเสื่อมราคาครุภัณฑ์โครงการ`)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleOnExport = () => {
    const request = {
      assetCode: searchRequest.assetCode,
      assetName: searchRequest.assetName,
      assetType: searchRequest.assetType,
      calDate: searchRequest.calDate,
    }
    // console.log('handleOnExportRequest==>', request)

    handleExportFile(request)
  }

  return (
    <>
      <Panel shaded bordered>
        {formSchema?.searchForm && (
          <div style={{ marginTop: 0 }}>
            <ListDepreciationAssetsSearch
              schema={formSchema.searchForm}
              onSearch={onSearch}
              loading={isLoading}
            />
          </div>
        )}

        <Row style={{ marginTop: 20 }}>
          <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <IconButton
              appearance="ghost"
              icon={<Icon icon="print" className="bt-gost-icon-radius" />}
              onClick={() => {
                handleOnExport({})
                // console.log('xxxx')
              }}
            >
              Export Excel
            </IconButton>
          </Col>
        </Row>

        <ListDepreciationAssetsTable
          schema={formSchema?.result}
          loading={isLoading}
          onReload={onReload}
          page={page}
          displayLength={displayLength}
        />
      </Panel>
    </>
  )
}
